import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { 
  LayoutDashboard, 
  MapPin, 
  Calendar, 
  DollarSign, 
  Users, 
  Mail, 
  Settings, 
  LogOut,
  Menu,
  X,
  Info,
  Bot,
  Music,
  Database
} from 'lucide-react';

const Layout = ({ onLogout }) => {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  const handleLogout = () => {
    onLogout();
    navigate('/auth');
  };

  const navItems = [
    { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/venues', label: 'Venues', icon: MapPin },
    { path: '/events', label: 'Events', icon: Calendar },
    { path: '/artists', label: 'Artists', icon: Music },
    { path: '/crm', label: 'CRM', icon: Database },
    { path: '/contacts', label: 'Contacts', icon: Users },
    { path: '/mailing-list', label: 'Mailing List', icon: Mail },
    { path: '/financials', label: 'Financials', icon: DollarSign },
    { path: '/maaike', label: 'Maaike', icon: Bot },
    { path: '/settings', label: 'Settings', icon: Settings },
  ];

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      {/* Mobile menu button */}
      <button
        onClick={() => setSidebarOpen(!sidebarOpen)}
        className="lg:hidden fixed top-4 left-4 z-50 p-2 bg-[#1A1A1A] rounded-lg"
      >
        {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Sidebar */}
      <aside className={`
        fixed top-0 left-0 h-full bg-[#1A1A1A] border-r border-[#333333] 
        transition-transform duration-300 z-40
        ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}
        lg:translate-x-0 w-64
      `}>
        <div className="p-6">
          <h1 className="text-2xl font-light tracking-wider mb-1">organise</h1>
          <p className="text-[#888888] text-sm">aftermidnight department</p>
        </div>

        <nav className="mt-8">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              onClick={() => setSidebarOpen(false)}
              className={({ isActive }) => `
                flex items-center gap-3 px-6 py-3 transition-all duration-300
                ${isActive 
                  ? 'text-[#D4A574] bg-[#0A0A0A] border-r-2 border-[#D4A574]' 
                  : 'text-[#CCCCCC] hover:text-white hover:bg-[#0A0A0A]'
                }
              `}
            >
              <item.icon size={20} />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <button
          onClick={handleLogout}
          className="absolute bottom-6 left-6 right-6 flex items-center gap-3 px-4 py-3 
                     text-[#888888] hover:text-white transition-all duration-300"
        >
          <LogOut size={20} />
          <span>Logout</span>
        </button>
      </aside>

      {/* Main content */}
      <main className="lg:ml-64 min-h-screen">
        <div className="p-4 lg:p-8">
          <Outlet />
        </div>
      </main>

      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div 
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-30"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  );
};

export default Layout;
